export default __webpack_public_path__ + "static/media/quote-image.c0f32138.svg";